
<template>
  <div class="successOpen">
    <h5>领取成功</h5>
    <div class="pic_success">
      <img src="../assets/act/success.png" alt="" />
    </div>
    <div class="congratulations">恭喜您成功领取小升初专题</div>
    <div class="downLoadTips">赶紧下载超级课堂app去学习吧～</div>
    <div class="btn" @click="downLoad">下载超级课堂app</div>
    <div class="box" v-show="show === 'true'">
      <p>登录账号：{{phone}}</p>
      <p>密码：123456</p>
      <p>（进入app可自行修改密码）</p>
    </div>
  </div>
</template>

<script>

export default {
  name: "successOpen",
  data() {
    return {
      show: false,
      phone: ''
    };
  },

  mounted() {
    this.show = this.$route.query.new;
    this.phone = this.$route.query.phone;
  },
  methods: {
    //封装一个方法用来判断是安卓还是ios
    isAndroid_ios() {
      var u = navigator.userAgent,
        // eslint-disable-next-line no-unused-vars
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      // eslint-disable-next-line no-unused-vars
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return isAndroid == true ? true : false;
    },
    //下载超级课堂app的点击事件
    downLoad() {
      if (this.isAndroid_ios()) {
        //安卓的下载地址
        window.location.href =
          "https://sj.qq.com/myapp/detail.htm?apkName=com.cjkt.student";
      } else {
        //ios的下载地址
        window.location.href =
          "https://itunes.apple.com/cn/app/chao-ji-ke-tang-quan-guo-shou/id1139648697?mt=8";
      }
    },
  },
};
</script>
<style lang="scss">
.successOpen {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  color: #333;
  min-height: 100vh;
  h5 {
    margin: .5rem auto;
    text-align: center;
    font-size: .9rem;
    font-weight: 500;
  }
  .pic_success {
    margin-top: 3rem;
    img {
      margin: 0 6.3rem .75rem;
      width: 6.2rem;
      height: 7.6rem;
    }
  }
  .congratulations {
    font-size: .9rem;
    font-weight: 600;
    text-align: center;
    margin-bottom: .35rem;
  }
  .downLoadTips {
    font-size: .75rem;
    text-align: center;
    color: #666;
    padding-left: .25rem;
  }
  .btn {
    margin: 1.5rem auto;
    width: 14.5rem;
    height: 2.2rem;
    line-height: 2.2rem;
    background: linear-gradient(90deg, #FFB336 0%, #FF7C19 100%);
    border-radius: 1.1rem;
    font-size: .75rem;
    color: #fff;
    text-align: center;
  }
  .box {
    text-align: center;
    color: #999;
    font-size: .7rem;
    p {
      margin: 0 auto .12rem;
    }
  }
}
</style>
